import { getBioLogById } from '../services/bioLogsApi';
import { applyPatchWithPartialProtection, mergeUpdateWithPartialProtection } from './syncUtils';

const transformBioLog = (resource) => {
  if (!resource) return null;
  return {
    ...resource,
    type: 'bio_log',
    resource_type: 'bio_log',
  };
};

const bioLogSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      // FIX: Use the specific domain API (getBioLogById) instead of the generic fetchResource.
      // The generic fetcher hits /api/v1/resources/bio_log which is not configured on the backend.
      const newResource = await getBioLogById(content.resource_id);
      
      if (!newResource) return currentMap;
      
      const transformed = transformBioLog(newResource);
      return { ...currentMap, [content.resource_id]: transformed };
    } catch (error) {
      console.error('[bioLogSyncDriver] Failed to sync created bio_log:', error);
      return currentMap;
    }
  },

  handleUpdated(currentMap, content) {
    if (!content.value) return currentMap;
    const existing = currentMap[content.resource_id];
    const protectedValue = mergeUpdateWithPartialProtection(existing, content.value);
    const transformed = transformBioLog(protectedValue);
    return { ...currentMap, [content.resource_id]: transformed };
  },

  handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    // If we don't have it in memory, we can't patch it. 
    // Ideally, we might want to fetch it here too, but usually handleCreated covers the initial load.
    if (!resourceToPatch) return currentMap; 
    
    try {
      const patched = applyPatchWithPartialProtection(resourceToPatch, content.patches);
      const transformed = transformBioLog(patched);
      return { ...currentMap, [content.resource_id]: transformed };
    } catch (e) {
      console.error('[bioLogSyncDriver] Patch failed:', e);
      return currentMap;
    }
  },
};

export default bioLogSyncDriver;